import * as React from 'react';
import { Bars3CenterLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { animated, config, useSpring } from '@react-spring/web';

import { NavigationBarProps, NavigationButton } from '../../../';

type IHamburgerComponentProps = {
  background?: NavigationBarProps['background'];
  isOpen?: boolean;
  testId?: string;
  className?: string;
};

export const HamburgerComponent: React.FunctionComponent<IHamburgerComponentProps> = ({
  background,
  isOpen,
  testId,
  ...rest
}) => {
  const iconAnimation = useSpring({ transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)', config: config.default });
  return (
    <NavigationButton
      {...{
        as: 'button',
        ...rest,
      }}
      twStyle={background === 'white' ? 'text-black' : 'text-white'}
      isDropdownItem
      noPadding
      testId="hamburger-button"
    >
      <animated.div style={iconAnimation}>
        {!isOpen ? (
          <Bars3CenterLeftIcon className="w-6 h-6 min-w-[24px]" />
        ) : (
          <XMarkIcon className="w-6 h-6 min-w-[24px]" />
        )}
      </animated.div>
    </NavigationButton>
  );
};

export default HamburgerComponent;
